export default "__VITE_ASSET__Pg4L_W9r__"